import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import StyledIcon from '../Icon/styled.js';
import _Paragraph from 'reakit/Paragraph';

var Paragraph = styled(_Paragraph).withConfig({
  displayName: "styled__Paragraph",
  componentId: "sc-1qnv201-0"
})(["&:not(:last-child){margin-bottom:", "rem;}& ", "{top:0.15em;}&{", ";}"], space(4), selector(StyledIcon), theme('fannypack.Paragraph.base'));

export default Paragraph;
export { Paragraph };
